/**
 * 在线咨询相关路由
 */
export default [
  {
    path: '/consult/doct',
    redirect: '/consult/doct/findAss',
    component: () => import('Pages/consult/doct'),
    children: [
      {
        path: 'find',
        meta: {
          title: '找医生'
        },
        component: () => import('Pages/consult/doct/find')
      },
      {
        path: 'findAss',
        meta: {
          title: '找医助'
        },
        component: () => import('Pages/consult/doct/findAss')
      },
      {
        path: 'selection',
        meta: {
          title: '问医生'
        },
        component: () => import('Pages/consult/doct/selection')
      },
      {
        path: 'my',
        meta: {
          title: '问医生'
        },
        component: () => import('Pages/consult/doct/my')
      }
    ]
  },
  {
    path: '/consult/choiceness-details/:id',
    component: () => import('../Pages/consult/choiceness-details.vue')
  },
  /**
   * query
   * ***** roomPrice
   */
  {
    path: '/consult/choose-depart',
    component: () => import('Pages/consult/choose-depart.vue')
  },
  {
    path: '/consult/doctor-card/:docId',
    props: true,
    meta: {
      title: '医生主页'
    },
    redirect: to => {
      Log('to', to)
      const {params, query} = to
      return {path: '/doc/card/' + params.docId, query}
    }
    //component: () => import('Pages/consult/doctor-card.vue')
  },
  /**
   * 精选咨询全部
   * * query
   * **** docId
   * **** docName
   */
  {
    path: '/consult/doctor-card-selection',
    component: () => import('Pages/consult/doctor-card-selection.vue')
  },
  /**
   * 医生说全部
   * * query
   * **** docId
   * **** docName
   */
  {
    path: '/consult/consult-snsKnowledge',
    component: () => import('Pages/consult/consult-snsKnowledge.vue')
  },
  /**
   * 医生相册全部
   */
  {
    path: '/consult/doctor-album',
    component: () => import('Pages/consult/doctor-album.vue')
  },
  /**
   * 医生文章全部
   * * query
   * **** docId
   * **** docName
   */
  {
    path: '/consult/article-list',
    component: () => import('Pages/consult/article-list.vue')
  },
  /**
   * params
   * ****** id
   */
  {
    path: '/consult/details/:id',
    component: () => import('../pages/consult/details.vue')
  },
  {
    path: '/consult/search',
    meta: {
      title: '搜索'
    },
    component: () => import('Pages/consult/search.vue')
  },
  /**
   * query
   * ***** docId
   * ***** docName
   * ***** roomPrice
   * 或者
   * ***** deptId
   * ***** deptName
   * ***** roomPrice
   */
  {
    path: '/consult/publish',
    component: () => import('Pages/consult/publish.vue')
  },
  {
    path: '/consult/report-read',
    component: () => import('Pages/consult/report-read.vue')
  },
  {
    path: '/consult/patient/add',
    component: () => import('Pages/consult/patient-add.vue')
  },
  /**
   * 咨询评价
   * params
   * ****** id 模块id（moudleId:咨询id 、 网约护士时用预约id）
   * query
   * ****** sysModuleType  模块名称（sysModuleType: CONSULT_INFO咨询 NURSE-网约护士）
   * ****** consultType 模块细分 当模块为网约护士时，不用传（"PLATFORMPIC", "平台图文问诊"，"ONE2ONEPIC", "一对一图文" ， VIDEO-视频咨询）
   */
  {
    path: '/consult/evaluate/:id',
    component: () => import('Pages/consult/evaluate.vue')
  },
  /**
   * params
   * ****** id
   */
  {
    path: '/consult/article/:id',
    meta: {
      title: '文章详情'
    },
    component: () => import('Pages/consult/article-detail.vue')
  },
  {
    path: '/consult/hos-scheme/:hosId',
    props: true,
    component: () => import('Pages/consult/hos-scheme.vue')
  },
  /**
   * params
   * ****** docId
   */
  {
    path: '/consult/commentlist/:docId',
    component: () => import('../pages/consult/comment-list.vue')
  },
  /**
   *  热门科室列表
   *
   * */
  {
    path: '/hotDept/find',
    component: () => import('../pages/consult/hot-dept-find.vue')
  },
  {
    path: '/third/returnUrl',
    component: () => import('../pages/consult/returnUrl.vue')
  },
]



// WEBPACK FOOTER //
// ./src/router/consult.js